 import React from "react";
 
 const Spinner = () => {
    return (
      <div className={`spinner-grow spinner-grow-sm `} role="status">
        <span className="visually-hidden"></span>
      </div>
    );
  };

  export default Spinner;